import { render, staticRenderFns } from "./PrivacyZones.vue?vue&type=template&id=5a26249c&scoped=true&"
import script from "./PrivacyZones.vue?vue&type=script&lang=js&"
export * from "./PrivacyZones.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyZones.vue?vue&type=style&index=0&id=5a26249c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a26249c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a26249c')) {
      api.createRecord('5a26249c', component.options)
    } else {
      api.reload('5a26249c', component.options)
    }
    module.hot.accept("./PrivacyZones.vue?vue&type=template&id=5a26249c&scoped=true&", function () {
      api.rerender('5a26249c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/PrivacyZones.vue"
export default component.exports